import { render } from "./selectField2.vue?vue&type=template&id=0450bf6b"
import script from "./selectField2.vue?vue&type=script&lang=js"
export * from "./selectField2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__